import { Typography } from '@musinsa/mds';
import type { FC, HTMLAttributes } from 'react';
import { twMerge } from 'tailwind-merge';

const DISPLAY_NAME = 'ProductInformation.GoodsName';

interface Props extends Pick<HTMLAttributes<HTMLDivElement>, 'onClick'> {
  goodsName: string;
  className?: string;
}

export const GoodsName: FC<Props> = ({ goodsName, className, onClick }) => (
  <Typography
    variant="body13pxReg"
    className={twMerge('line-clamp-2 pt-1', className)}
    onClick={onClick}
  >
    {goodsName}
  </Typography>
);

GoodsName.displayName = DISPLAY_NAME;
